import * as actions from "./actionsTypes";

const initialData = {
  loaderTrainings: false,
  trainings: null,
  trainingsFail: null,
  saveLoaderTrainings: false,
  trainingsFormError: null,
};

export default function TrainingsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_TRAININGS:
      return { ...state, loaderTrainings: action.payload };

    case actions.GET_TRAININGS:
      return { ...state, trainings: action.payload };

    case actions.TRAININGS_FAIL:
      return { ...state, trainingsFail: action.payload };

    case actions.SAVE_LOADER_TRAININGS:
      return { ...state, saveLoaderTrainings: action.payload };

    case actions.FORM_TRAININGS_FAIL:
      return { ...state, trainingsFormError: action.payload };

    default:
      return state;
  }
}
